<script setup lang="ts">
  const props = defineProps({
    message: {
      type: String,
      default: 'tradeBlocked',
    },
  })
  const messages = {
    tradeBlocked:
      'Your account is currently blocked from in-game trading. If you proceed to use the Marvel Machine, you will not be able to trade the acquired Marvel Machine items with other players or drop items in-game.',
  }
</script>

<template>
  <MarvelBoxy :class="'mavel-machine-in-message'" :type="'type1'">
    <div class="mavel-machine-in-message__message">
      {{ messages[props.message as keyof typeof messages] }}
    </div>
  </MarvelBoxy>
</template>

<style lang="scss">
  .mavel-machine-in-message {
    max-width: calc(900px * var(--marvel-desktopRatio));
    margin: 0 auto;
  }
  .mavel-machine-in-message__message {
    padding: calc(20px * var(--marvel-desktopRatio)) calc(30px * var(--marvel-desktopRatio));
    font-size: calc(15px * var(--marvel-desktopRatio));
    color: #cd253a;
    font-weight: bold;
  }

  @media #{$mobileForMarvel} {
    .mavel-machine-in-message {
      max-width: none;
      margin: 0 auto;
    }
    .mavel-machine-in-message__message {
      padding: 1.1vw 3.5vw;
      font-size: 2.6vw;
    }
  }
</style>
